<template>
  <div
    class="card"
    @click="selectShoe"
    @keyup.enter="selectShoe"
    :class="{ interact: selectable }"
  >
    <div class="card-top" :class="{ selectable }">
      <span>I have this one</span>
      <span
        class="dot"
        :style="{ backgroundColor: isSelected ? '#0c6b68' : '#fff' }"
      ></span>
    </div>
    <div class="img-wrapper">
      <img
        :src="
          require(`../assets/images/shoe-images/${shoe.name
            .split(' ')
            .join('-')}.jpg`)
        "
        :alt="shoe.name || 'Shoe'"
      />
    </div>
    <div class="card-bottom">
      <span>{{ shoe.name }}</span>
      <span style="float: right;">€ {{ shoe.price }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Shoe',
  props: {
    shoe: {
      type: Object,
      default: () => {}
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: false
    },
    paddingTop: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectShoe() {
      this.$emit('shoe-selected', this.shoe)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 325px;
  height: 400px;
  background-color: #efefef;
  margin: 0 auto;
  padding: 32px;
  box-sizing: border-box;

  &.interact {
    cursor: pointer;
    &:hover,
    &:focus {
      outline: 1px solid #0c6b68;
    }
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    max-width: 100%;
    height: auto;
    padding: 16px;
  }

  &-top {
    align-self: flex-end;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    visibility: hidden;

    &.selectable {
      visibility: visible;
      margin-bottom: 60px;
    }

    .dot {
      width: 25px;
      height: 25px;
      border-radius: 100px;
      margin-left: 23px;
    }
  }

  &-bottom {
    margin-top: 27px;
  }

  .img-wrapper {
    margin: 0 auto;
    align-self: flex-end;
  }

  img {
    width: 250px;
  }
}
</style>
